import * as io from 'io-ts';

export const POSCheckoutCapabilities = io.union([
  io.literal('TapToPay'),
  io.literal('KeyEntry'),
]);

export type POSCheckoutCapabilities = io.TypeOf<typeof POSCheckoutCapabilities>;

export const MerchantDetails = io.type({
  id: io.string,
  name: io.string,
  url: io.string,
  merchantLogo: io.string,
  phoneNumber: io.string,
  hipaaRestricted: io.boolean,
  instorePickupAvailable: io.boolean,
  posCheckoutCapability: io.union([
    io.array(POSCheckoutCapabilities),
    io.null,
    io.undefined, // TODO: Remove me when API is ready
  ]),
  borrowRatioBPS: io.union([io.number, io.undefined]),
  canViewCapacity: io.boolean,
});

export type MerchantDetails = io.TypeOf<typeof MerchantDetails>;

export const MerchantDetailsResponse = io.type({
  merchant: MerchantDetails,
});

export type MerchantDetailsResponse = io.TypeOf<typeof MerchantDetailsResponse>;
